<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { ResourceTypeEnum } from '@/types/generated'
  import OfficeEditor from '@/components/app/editor/OfficeEditor.vue'

  interface Props {
    documentUuid?: string
    resourceType?: ResourceTypeEnum
    gobackUrl?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    resourceType: ResourceTypeEnum.DOCUMENT
  })

  const route = useRoute()
  const documentUuid = computed(() => props.documentUuid || (route.params.documentUuid as string))
</script>

<template>
  <div class="office-editor-view">
    <OfficeEditor
      :document-uuid="documentUuid"
      :resource-type="props.resourceType"
      :goback-url="props.gobackUrl"
      :check-for-navbar="true"
    />
  </div>
</template>

<style scoped>
  .office-editor-view {
    position: fixed;
    top: 56px;
    left: 0;
    right: 0;
    bottom: 0;
  }
</style>
